import React, { useState} from "react";
import ContinueButton from "../../Registration/ContinueButton";
import { useNavigate } from "react-router-dom";
import CreatePassword from "../../Registration/PasswordPage";
import { useSelector } from "react-redux";

const NewPassword = ({ setNextPageTriggered, handleSubmit, newPassword, setNewPassword, confirmPassword, setConfirmPassword }) => {
  const navigate = useNavigate();
  const [passwordError, setPasswordError] = useState("");
  const [validationErrors, setValidationErrors] = useState([]);
  const [passwordValidationClicked, setPasswordValidationClicked] =
    useState(false);
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    newPassword: false,
    confirmPassword: false,
  });
  const { email } = useSelector((state) => state.auth);

  const togglePasswordVisibility = (field) => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handlePasswordUpdate = async () => {
    setPasswordValidationClicked(true);
    let errors = [];
    
    if (newPassword.length < 8) errors.push("Password must be at least 8 characters long.");
    if (!/[A-Z]/.test(newPassword)) errors.push("Password must contain at least one uppercase letter.");
    if (!/\d/.test(newPassword)) errors.push("Password must contain at least one number.");
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(newPassword)) errors.push("Password must contain at least one special character.");
    if (newPassword !== confirmPassword) errors.push("Passwords do not match.");

    if (errors.length > 0) {
      setValidationErrors(errors);
      setPasswordError(errors.join(" "));
      return;
    }

    await handleSubmit();
    setNextPageTriggered(true);
  };

  return (
    <section className="flex flex-col items-center min-h-screen justify-center bg-white py-10 px-6">
      <header className="text-center mb-14">
        <h1 className="text-2xl font-semibold text-[#1d2639]">
          Reset Your Password
        </h1>
        <p className="text-base font-medium text-[#7e7e7e] w-full sm:w-[394px]">
          {`Create your new password for ${email}`}
        </p>
      </header>
      <div className="w-full sm:w-[572px]">
        <CreatePassword
          newPassword={newPassword}
          setNewPassword={setNewPassword}
          confirmPassword={confirmPassword}
          setConfirmPassword={setConfirmPassword}
          passwordVisibility={passwordVisibility}
          togglePasswordVisibility={togglePasswordVisibility}
          passwordValidationClicked={passwordValidationClicked}
          passwordError={passwordError}
          setPasswordError={setPasswordError}
          validationErrors={validationErrors}
        />
      </div>

      <ContinueButton
        isDisabled={
          passwordError ||
          !newPassword || 
          !confirmPassword
        }
        onClick={handlePasswordUpdate}
        label="Reset Password"
      />
      <button
        className="text-[#7E7E7E] mt-4"
        onClick={() => navigate("/login")}
      >
        Back to login
      </button>
    </section>
  );
};

export default NewPassword;
